import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const BagSummary = ({ }) => {
  const cssStyle = {textDecoration: "none"};
  const deliveryStyle = {fontSize:"14px",color:"green"};
  const orderBeforeStyle = {fontSize:"13px", color:"black"}
  let productQuantity = useSelector(store => store.bag.bagListQuantity);
  const bagIds = useSelector(store => store.bag.cartList);  
  if(bagIds.length===0){
    window.location.href = '/';
  } 
  const items = useSelector(store => store.allItems);
  const finalItems = items.filter(item => {
    const itemIndex = bagIds.indexOf(item.id);
    return itemIndex >= 0;
  })    
    let totalItem = bagIds.length;
    let CONVENIENCE_FEES = 45;
    const REQUIRE_AMOUNT = 499;
    let totalMRP = 0;
    let totalDiscount = 0;
    let productQty = 1;

    finalItems.forEach((bagItem) => {
      productQty = productQuantity.find(el => el.id === bagItem.id);
      totalMRP += bagItem.product_price * productQty.quantity;
      if(bagItem.product_offer>0){
        totalDiscount += (bagItem.product_price * bagItem.product_offer/100) * productQty.quantity;       
      }
    })
    CONVENIENCE_FEES = (totalMRP - totalDiscount) > REQUIRE_AMOUNT ? 0 : CONVENIENCE_FEES; 

    let finalPayment = totalMRP - totalDiscount + CONVENIENCE_FEES;   
    //from here    
function addDays(date, days) {
  const newDate = new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
  return newDate;
}
const todayDate = new Date();
const days = 1;
const newDate = addDays(todayDate, days);
const deliveryDateArray = newDate.toDateString().split(" ");
    //End here  
    return <div className="bag-summary">
        <h5>PRICE DETAILS ( {totalItem} Items )</h5>
        <h6>Total MRP           &#x20B9;{Math.round(totalMRP)}</h6>
        <h6>Discount on MRP     &#x20B9;{Math.round(totalDiscount) }</h6>
        <h6>Convenience Fee     &#x20B9;{ CONVENIENCE_FEES}</h6>
        <span style={deliveryStyle}>Delivery by {`${deliveryDateArray[0]}, ${deliveryDateArray[2]} ${deliveryDateArray[1]}`}</span><br />
        <span style={orderBeforeStyle}>if ordered before 11:59 PM</span>
        <hr />
        <h5>Total Amount   &#x20B9;{ Math.round(finalPayment)}</h5>
      <div>
        { localStorage.getItem('access') ?  <button type="button" className="btn btn-info"><Link to="/place-order" className="text-white" style={cssStyle}>Order Review</Link></button> : <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#myModal">Order Review</button> }
            &nbsp;&nbsp;
            <button type="button" class="btn btn-warning"><Link to="/" className="text-white" style={cssStyle}>Continue shopping</Link></button>
        </div>

    </div>

}
export default BagSummary;